export default "/images/vendor/@coreui/icons/svg/flag/cif-by.svg?243262ddb5b2fbe0747038dd7c5ec4ff";